import React from 'react';
import { Box, Divider } from '@mui/material';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { pdBannerDispatch } from 'reducers/HomeReducer';
import PopularDestinationTable from 'app/form/PopularDestinationTable';

const PopularDestinationList = () => {
	const { pdInfo } = useSelector((state) => state.home);
	const dispatch = useDispatch();
	useEffect(() => {
		dispatch(pdBannerDispatch());
	}, []);
	return (
		<div>
			<Box
				style={{
					boxShadow:
						'rgba(0, 0, 0, 0.06) 0px 3px 3px -2px, rgba(0, 0, 0, 0.04) 0px 3px 4px 0px, rgba(0, 0, 0, 0.04) 0px 1px 8px 0px',
					padding: 30,
					background: 'white',
				}}>
				<h2>Popular Destination List</h2>
				<Divider style={{ marginTop: 20, marginBottom: 20 }} />
				<PopularDestinationTable />
			</Box>
		</div>
	);
};

export default PopularDestinationList;
